export function cyrb53(str: string, seed = 0): number {
  let h1 = 0xdeadbeef ^ seed;
  let h2 = 0x41c6ce57 ^ seed;
  for (let i = 0; i < str.length; i++) {
    const ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
  h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
  h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}

export function fnv1a(data: ArrayLike<number>): number {
  let hash = 2166136261;
  for (let i = 0; i < data.length; i++) {
    hash ^= data[i]! & 0xff;
    hash = Math.imul(hash, 16777619);
    hash ^= (data[i]! >>> 8) & 0xff;
    hash = Math.imul(hash, 16777619);
    hash ^= (data[i]! >>> 16) & 0xff;
    hash = Math.imul(hash, 16777619);
    hash ^= (data[i]! >>> 24) & 0xff;
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}

export function fnv1aFloat32(data: Float32Array): number {
  const view = new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
  let hash = 2166136261;
  for (let i = 0; i < view.length; i++) {
    hash ^= view[i]!;
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}
